<template>
    <x-alert :value="show" color="error" icon="report" outline>
        Facility is inactive, contact admin broker
    </x-alert>
</template>

<script>
export default {
    name: "FacilityInactiveAlert",
    props: ["show"],
};
</script>

<style lang="scss" scoped>
    .x-alert {
        color: white !important;
        background-color: rgba(220, 0, 15, 0.1) !important;
        height: 40px;

        :deep(.x-alert__text) {
            font-size: 14px;
            line-height: 16px;
            font-weight: 600;
        }
    }
</style>


